module.exports = __webpack_public_path__ + "img/p2-34.3e8fed16.png";